import Column from 'components/UIKit/Flex/Column';

const SubmitDisclaimer = () => (
  <Column style={{ padding: '10px', alignItems: 'stretch' }}>
    <p>
      DISCLAIMER: By submitting data to the GDC, you are acknowledging that data
      will be released within six months per the NCI Genomic Data Sharing Policy.
      During the data submission period, the data may be accessible for viewing
      only to the submitting investigators and collaborators for a period not to
      exceed six months. Once submitted, data will be processed and validated by
      the GDC including the generation of derived data for applicable data sets.
      Submitted data will be released and available via controlled access for research
      that is consistent with the dataset’s “data use limitations” either six months
      after data submission or at the time of first publication (whichever comes first).
      Community resources could be released earlier than the six-month deferral
      regardless of publication status.
    </p>
    <p>
      Data Sharing Requirement: By submitting data to the GDC, a submitter indicates
      understanding and agreement that data will be made available to the scientific
      community at large, according to the data submitter's Genomic Data Sharing
      Plan as required. Controlled access data will be made available to members
      of the community having the appropriate dbGaP Data Use Certification.
      The GDC will also produce harmonized data (raw and derived) based on the originally submitted data.
    </p>
    <p>
      NOTE: The GDC will not preserve an exact copy of the originally submitted data,
      however the GDC will preserve the original reads and quality scores.
    </p>
    <p>
      After data is released, either by submitter request to the GDC, or by approval
      of the Center for Cancer Genomics, harmonized raw and GDC-generated derived
      data will be made available to the public via the GDC Data Portal and GDC data access tools.
    </p>
  </Column>
);

export default SubmitDisclaimer;
